const ROLES = {
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_STAFF: "ROLE_STAFF",
  ROLE_LEADER: "ROLE_LEADER",
};

export { ROLES };
